// This needs to be in this style to be used by ndjson-cli

module.exports = data => {
  const vif_0_3J = data['VIF_0_3'] > 0
  const vif_3_6J = data['VIF_3_6'] > 0
  const nmb = data['VS_Ki_NMB'] === 'ja' ? 1 : 0

  if (vif_0_3J && vif_3_6J && nmb) return 'VIF+'
  if (vif_0_3J || vif_3_6J) return 'VIF'

  if (!data['oeffTag_0_3J'] && !data['oeffTag_3_6J'] && !nmb) return 'E'

  const betr_0_3J = data['oeffTag_0_3J'] ? 1 : 0
  const betr_3_6J =
    data['oeffTag_3_6J'] === '9,5' || data['oeffTag_3_6J'] === '8' ? 1 : 0
  const sum = betr_0_3J + betr_3_6J + nmb

  return ['D', 'C', 'B', 'A'][sum]
}



// WEBPACK FOOTER //
// ./src/helpers/calculateVIFKategorie.js